module.exports = __webpack_public_path__ + "img/Baroda_office_image_4.f7a3c9b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/Baroda/Baroda_office_image_4.jpeg
// module id = 751
// module chunks = 1